import { getUserInfo } from '@/api';
//状态，不允许直接对state操作，只能通过mutations或者actions改变
const state = {
    myinfo:{
        uid:null,
        nickName:'',
        rongId:'',
        mobile:'',
        sign:'',
        headpic:''
    }
}


//同步方法
const mutations = {
    setMyInfo (state) {
        getUserInfo({
            uid:sessionStorage.getItem('myUid')
        }).then(res => {
            if(res.code == 0){
                state.myinfo = {
                    uid:res.data.uid,
                    nickName:res.data.nickname,
                    mobile:res.data.mobile,
                    sign:res.data.sign,
                    headpic:res.data.headpic
                }
            }
        }).catch(err => {
            console.log(err);
        })
        
    }
}

//异步方法
const actions = {
    setMyInfoAction( {commit} ){
        commit('setMyInfo')
    }
}
export default{
    namespaced: true,
    state,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/myself.js